/**************************************************
 * Nombre:       Seccion_Checkout
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, CircularProgress, Grid, Skeleton, Typography} from "@mui/material";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Datos_Entrega from "../Formularios/Formulario_Datos_Entrega";
import Formulario_Direccion_Entrega from "../Formularios/Formulario_Direccion_Entrega";
import {useEffect, useState} from "react";
import {obtenerDimencionTotal} from "../../Modulo_envios/Funciones/obtenerDimencionTotal";
import {useFuncionesCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useFuncionesCarritoLateral";
import {obtenerPesoTotalEnKilos} from "../../Modulo_envios/Funciones/obtenerPesoTotalEnKilos";
import {obtenerDaneCode} from "../../Modulo_envios/Funciones/obtenerDaneCode";
import {obtenerValorTotal} from "../../Modulo_envios/Funciones/obtenerValorTotal";
import Tarjetas_Producto_Lateral_Check from "../../Modulo_Carrito_Lateral/Tarjetas/Tarjetas_Producto_Lateral_Check";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {
    CheckCircle,
    ContentCopy,
    Face6,
    HomeOutlined,
    LocalShippingOutlined,
    ReplayOutlined,
    WhatsApp
} from '@mui/icons-material'
import Tarjeta_Empresa_Envio_Lateral from "../../Modulo_Envios_2026/Tarjetas/Tarjeta_Empresa_Envio_Lateral";
import {obtenerValorEnvio} from "../../CodCliente/obtenerValorEnvio";
import {NEGRITA, VALORENVIOGRATIS} from "../../Constantes";
import {escogerCotizacionEconomica} from "../../Modulo_Envios_2026/Funciones/escogerCotizacionEconomica";
import BotonWompiAdentro from "../../Modulo_Wompi_Adentro/Componentes/BotonWompiAdentro";
import {guardarDataLocal} from "../../Modulo_Optimizacion_Data/Funciones/guardarDataLocal";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from '../../Recursos/logo_redondo.svg'
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";
import {obtenerDatoUrl} from "../../Modulo_Wompi_Adentro/Funciones/obtenerDatoUrl";
import {obtenerDatosTransaccion} from "../../Modulo_Wompi_Adentro/Funciones/obtenerDatosTransaccion";
import {adap_datos_pago} from "../../CodCliente/Adaptadores/adap_datos_pago";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import Tarjeta_Estado_Pedido from "../Tarjetas/Tarjeta_Estado_Pedido";
import Tarjeta_Estado_Envio from "../Tarjetas/Tarjeta_Estado_Envio";
import {solicitarMensajeGuia} from "../../CodCliente/solicitarMensajeGuia";
import {copiarUrlPortapapeles} from "../../Utilidades/copiarUrlPortapapeles";
import {adap_producto_carrito_lateral} from "../../Modulo_Carrito_Lateral/Adaptadores/adap_producto_carrito_lateral";
import {irArriba} from "../../Utilidades/irArriba";
import {iniciarChatWass} from "../../Utilidades/iniciarChatWass";
import {limpiarCelular} from "../../Modulo_formularios/Funciones/limpiarCelular";
import Formulario_Codigo_Descuento from "../Formularios/Formulario_Codigo_Descuento";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {obtenerValorDescuento} from "../../CodCliente/obtenerValorDescuento";
import {obtenerCotizacionesEnvio} from "../../Modulo_Envios_2026/Funciones/obtenerCotizacionesEnvio";


const Seccion_Checkout = () => {
    const {sCell, masSM, sTab} = useResponsive()
    const {productos, resetarCarrito, adicionarProducto} = useFuncionesCarritoLateral()
    const {Cargador, Avisos, terminar, iniciarCarga, cerrarCarga} = useCargador({logoRedondo: logo})
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {
        props: propsDescuento,
        obtenerEntidad: obtenerEntidadDescuento,
        setError
    } = useFormulario({valoresDefecto: {}})
    const [cotizaciones, setCotizaciones] = useState([])
    const [idEnvio, setIdEnvio] = useState('')
    const [valorEnvio, setValorEnvio] = useState(-1)
    const [empresaEnvio, setEmpresaEnvio] = useState('')
    const [tiempoEnvio, setTimpoEnvio] = useState('')
    const [numero, setNumero] = useState('')
    const [datosPago, setDatosPago] = useState(null)
    const [cargandoCotizaciones, setCargandoCotizaciones] = useState(false)
    const [cotizo, setCotizo,] = useState(false)
    const [descuentos, setDescuento] = useState(0)
    const [valorDescuento, setValorDescuento] = useState(0)
    const [codigoCupon, setCodigoCupon] = useState('')
    const [cotizacionEconomica, setCotizacionEconomica] = useState({})

    const guardar = async () => {
        let entidad = await obtenerEntidad()
        entidad.id = numero
        entidad.estado = 'Nuevo'
        entidad.productos = productos
        entidad.valorEnvio = valorEnvio
        entidad.idEnvio = idEnvio
        entidad.empresaEnvio = empresaEnvio
        entidad.tiempoEnvio = tiempoEnvio
        entidad.celular = limpiarCelular(entidad.celular)
        entidad.valorDescuento = valorDescuento
        entidad.codigoCupon = codigoCupon ? codigoCupon.toUpperCase() : ''
        entidad.descuentos = descuentos
        entidad.estado = 'Nuevo'


        let conse = await obtenerConsecutivo({col: 'consecutivos', id: 'pedidos'})
        entidad.consecutivo = conse.data
        let dox = await guardarDoc('pedidos', entidad)
        if (dox.res) {

            window.fbq('track', 'InitiateCheckout', {
                content_type: 'product',
                contents: entidad.productos.map((it) =>
                    ({
                        id: it.id,
                        quantity: it.cantidad,
                        item_price: it.cantidad * it.valor
                    })
                ),
                content_ids: entidad.productos.map((it) => it.id),
                value: obtenerValorTotal(entidad.productos),
                currency: 'COP',                     // Moneda
                num_items: entidad.productos.length ? entidad.productos.length : 1
            });

            await aumentarConsecutivo({col: 'consecutivos', id: 'pedidos', actual: entidad.consecutivo})
            return true
        } else {
            terminar({aviso: 'No se pudo realizar el pedido, porfavor intenta nuevamente', variante: 'error'})
            return false
        }


    }

    const cambioEnvio = (index) => {

        let cotizacion = cotizaciones[index]

        if (cotizacion) {
            setValorEnvio(obtenerValorEnvio(cotizacion))
            setIdEnvio(cotizacion.idRate)
            setEmpresaEnvio(cotizacion.carrier)
            setTimpoEnvio(cotizacion.deliveryDays)
        }

        if (index === -1) {
            setValorEnvio(0)
            setIdEnvio('gratis')
            setEmpresaEnvio('Envio Gratis')
            setTimpoEnvio(escogerCotizacionEconomica(cotizaciones).deliveryDays)
        }

    }

    function filtrarPorPrecioUnico(array, propiedad) {
        const preciosVistos = new Set();

        return array.filter(item => {
            const valor = item[propiedad];
            if (preciosVistos.has(valor)) {
                return false; // Ya existe este precio, lo descartamos
            } else {
                preciosVistos.add(valor); // Es nuevo, lo registramos
                return true; // Lo mantenemos
            }
        });
    }

    const consultarEstadoPedido = async (idPago) => {

        let res = await obtenerDatosTransaccion(idPago)
        if (res) {

            let dox = await obtenerDoc('pedidos', res.reference)
            if (dox.res) {
                let pedido = dox.data
                let estadoPago = adap_datos_pago(res, dox.data)
                setDatosPago(adap_datos_pago(res, dox.data))
                setEntidad(dox.data)
                setDescuento(dox.data.descuento ? dox.data.descuento : 0)
                setValorDescuento(dox.data.valorDescuento ? dox.data.valorDescuento : 0)
                setCodigoCupon(dox.data.codigoCupon ? dox.data.codigoCupon : '')

                if (estadoPago.estado === 'APPROVED' && dox.data.estado !== 'APPROVED') {

                    window.fbq('track', 'Purchase', {
                        content_type: 'product',
                        contents: pedido.productos.map((it) =>
                            ({
                                id: it.id,
                                quantity: it.cantidad,
                                item_price: it.cantidad * it.valor
                            })
                        ),
                        content_ids: pedido.productos.map((it) => it.id),
                        value: pedido.valorPagado,
                        currency: 'COP',
                        num_items: pedido.productos.length ? pedido.productos.length : 1
                    });


                }

            } else {

                terminar({
                    aviso: 'Error al ver actualizacion de pedido, porfavor comuniquese con nosotros mediante los canales de atencion',
                    variante: 'error'
                })
            }

            cerrarCarga()
        }

    }

    const consultarGuia = async () => {

        iniciarCarga('Enviando Numero de Guia...')
        await solicitarMensajeGuia({pedido: datosPago})

        terminar({aviso: `Se enviara un whatsapp al numero ${datosPago.celular} con los datos de la guia`})


    }

    const copiar = async () => {

        copiarUrlPortapapeles().then(() => {
            terminar({aviso: 'Url Copiada'})
        }).catch(() => {
            terminar({aviso: 'Tu navegador no permite copiar la url', variante: 'error'})
        })

    }

    const comprarNuevamente = async () => {

        let prods = datosPago.productos

        iniciarCarga('Agregando al carrito')
        resetarCarrito()

        for (let i = 0; i < prods.length; i++) {
            let dox = await obtenerDoc('productos', prods[i].id)
            if (dox.res && dox.data) {
                console.log(dox.data)
                let prod = adap_producto_carrito_lateral({
                    producto: dox.data,
                    cantidad: prods[i].cantidad,
                    variacion: {nombre: prods[i].varianteNombre},
                })
                adicionarProducto(prod)
            }
        }
        setDescuento(0)
        setValorDescuento(0)
        setCodigoCupon('')
        cerrarCarga()
        irArriba()
        setDatosPago(null)

    }

    const aplicarDescuento = async () => {


        let entidad = await obtenerEntidadDescuento()
        iniciarCarga('Aplicando Descuento')
        let codigo = entidad.codigo


        codigo.replaceAll(' ', '')
        codigo.toUpperCase()
        let w = [where('codigo', '==', codigo), where('cangeado', '==', false)]
        let dox = await obtenerColWheres({col: 'cupones', wheres: w})
        if (dox.res && dox.data[0]) {
            let cupon = dox.data[0]
            setDescuento(cupon.porcentaje)
            setValorDescuento(obtenerValorDescuento({
                valor: obtenerValorTotal(productos),
                porcentaje: cupon.porcentaje
            }))
            setCodigoCupon(cupon.codigo)
        } else {
            setError("codigo", {
                type: "manual",
                message: "Este cupón no es válido o ya fue utilizado."
            })
            setValorDescuento(0)
            setCodigoCupon('')
            setDescuento(0)
        }

        cerrarCarga()

    }

    useEffect(() => {


        setCotizaciones([])
        let ciu = props.getValues('ciudad')
        let datos = props.getValues()
        if (ciu) {
            setCargandoCotizaciones(true)
            setValorEnvio(-1)
            setNumero(new Date().getTime() + 'PED')
            let ent = props.getValues()
            guardarDataLocal({clave: 'cliente', data: ent})


            let dimen = obtenerDimencionTotal(productos)
            let peso = obtenerPesoTotalEnKilos(productos)
            let dane = obtenerDaneCode(datos.departamento, datos.ciudad)

            datos.productos = productos
            obtenerCotizacionesEnvio({pedido: datos}).then((dox) => {
                setCotizo(true)
                if (dox.res) {
                    setCotizaciones(filtrarPorPrecioUnico(dox.data, 'flete'))
                    let eco = escogerCotizacionEconomica(dox.data)
                    setCotizacionEconomica(eco)
                    setIdEnvio(eco.idRate)
                    setValorEnvio(obtenerValorEnvio(eco))
                    setEmpresaEnvio(eco.carrier)
                    setTimpoEnvio(eco.deliveryDays)

                } else {
                    setCotizaciones([])
                }
                setCargandoCotizaciones(false)
            })

            /* obtenerCotizacion({
                 dimencionesTotal: dimen,
                 pesoTotal: peso,
                 codigoDane: dane,
                 bodega: BODEGA,
                 valorTotal: obtenerValorTotal(productos),
                 direccionEnvio: datos.direccion
             }).then((dox) => {
                 setCotizo(true)
                 if (dox.res) {
                     setCotizaciones(filtrarPorPrecioUnico(dox.data, 'flete'))
                     let eco = escogerCotizacionEconomica(dox.data)
                     setCotizacionEconomica(eco)
                     setIdEnvio(eco.idRate)
                     setValorEnvio(obtenerValorEnvio(eco))
                     setEmpresaEnvio(eco.carrier)
                     setTimpoEnvio(eco.deliveryDays)


                 } else {
                     setCotizaciones([])
                 }
                 setCargandoCotizaciones(false)
             })*/


        }

    }, [props.watch('ciudad')])


    useEffect(() => {

        irArriba()
        setCotizo(false)
        let idPago = obtenerDatoUrl({clave: 'id'})
        if (idPago) {
            iniciarCarga('Consultando Pedido...')
            consultarEstadoPedido(idPago).then()

        } else {
            setDatosPago(null)
        }

    }, []);


    useEffect(() => {

        if (descuentos && datosPago === null) {
            setValorDescuento(obtenerValorDescuento({
                valor: obtenerValorTotal(productos),
                porcentaje: descuentos
            }))
        }

    }, [obtenerValorTotal(productos)])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Cargador/>
            <Avisos/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: sCell ? 3 : 6, pt: sCell ? 3 : 4}}

            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', pb: 2}}>
                    <Typography
                        sx={{fontFamily: NEGRITA, fontSize: sCell ? 34 : 56, fontWeight: 700}}>CHECKOUT</Typography>
                </Grid>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 9}}
                    spacing={sTab ? 1 : 6}>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 7, md: 7}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontSize: sCell ? 16 : 18, fontWeight: 600}}>
                                <Face6 sx={{mt: 0.6, mb: -0.6, pr: 0.5, pl: 1, width: sCell ? 18 : 24}}/>
                                Datos de Entrega</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Formulario_Datos_Entrega props={props} editable={datosPago === null}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontSize: sCell ? 16 : 18, fontWeight: 600}}>
                                <HomeOutlined sx={{mt: 0.6, mb: -0.6, pr: 0.5, pl: 1, width: sCell ? 18 : 24}}/>
                                Direccion de Entrega</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: 'flex-start', mt: 2, mb: datosPago !== null ? 4 : 0}}>
                            <Formulario_Direccion_Entrega props={props} editable={datosPago === null}/>
                        </Grid>

                        {datosPago === null &&

                            <>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 3}}>
                                    <Typography sx={{fontSize: sCell ? 16 : 18, fontWeight: 600}}>
                                        <LocalShippingOutlined
                                            sx={{mt: 0.6, mb: -0.6, pr: 0.5, pl: 1, width: sCell ? 18 : 24}}/>
                                        Metodo de envio</Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{mt: 2}}
                                    spacing={2}
                                >


                                    {cargandoCotizaciones &&

                                        <Grid
                                            container
                                            justifyContent={'flex-start'}
                                            alignItems={'flex-start'}
                                            size={{xs: 12, sm: 12, md: 12}}>

                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'center'}}>
                                                <CircularProgress/>
                                            </Grid>

                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'center'}}>
                                                <Typography>Buscando Ruta</Typography>
                                            </Grid>

                                        </Grid>
                                    }

                                    {datosPago === null && obtenerValorTotal(productos) >= VALORENVIOGRATIS && cotizaciones.length > 0 &&

                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjeta_Empresa_Envio_Lateral item={{
                                                idCarrier: 0,
                                                carrier: 'Envio Gratis',
                                                product: `Compras mayor a ${formatoMoneda(VALORENVIOGRATIS)}`,
                                                extraInsurance: 0,
                                                flete: 0,
                                                minimumInsurance: 0,
                                                idRate: 'gratis',
                                                deliveryDays: cotizacionEconomica.deliveryDays
                                            }}
                                                                           index={-1}
                                                                           cambio={cambioEnvio}
                                                                           idEnvio={idEnvio}/>
                                        </Grid>
                                    }

                                    {cotizo && cotizaciones.length === 0 && !cargandoCotizaciones &&

                                        <>
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', px: 1}}>
                                                <Typography>No encontramos empresa de envios disponible para esta
                                                    ciudad</Typography>
                                            </Grid>


                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start', mt: 2}}>
                                                <Button
                                                    startIcon={<WhatsApp/>}
                                                    onClick={() => iniciarChatWass({mensaje: 'Hola Amevi'})}
                                                    variant={'outlined'} fullWidth>Comunicarme con atencion</Button>
                                            </Grid>

                                        </>

                                    }

                                    {cotizaciones.map((it, index) => {
                                        return (
                                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                                  sx={{justifyContent: 'flex-start'}}>
                                                <Tarjeta_Empresa_Envio_Lateral item={it} index={index}
                                                                               cambio={cambioEnvio}
                                                                               idEnvio={idEnvio}/>
                                            </Grid>

                                        )
                                    })}


                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 4, pb: 4}}>
                                    {valorEnvio >= 0 &&
                                        <BotonWompiAdentro numPago={numero}
                                                           valor={obtenerValorTotal(productos) + valorEnvio - valorDescuento}
                                                           funcion={guardar}/>
                                    }

                                </Grid>


                            </>
                        }


                    </Grid>


                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 5, md: 5}}
                        spacing={0}
                        sx={{
                            position: 'sticky',
                            top: 20,
                            pb: 5

                        }}
                    >


                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={1}
                            sx={{borderBottom: 1, pb: 2, mb: 2}}
                        >


                            {datosPago === null ?

                                productos.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjetas_Producto_Lateral_Check item={it} index={index}
                                            />
                                        </Grid>
                                    )
                                })

                                :

                                datosPago.productos.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjetas_Producto_Lateral_Check item={it} index={index}
                                                                             editable={false}/>
                                        </Grid>
                                    )
                                })


                            }


                        </Grid>

                        <Grid container size={{xs: 8, sm: 8, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Formulario_Codigo_Descuento props={propsDescuento} editable={datosPago === null}/>
                        </Grid>

                        <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'flex-end', mt: 0}}>
                            <Button
                                variant="outlined"
                                onClick={() => aplicarDescuento()}
                                sx={{pt: 1.5, pb: 1.5}}
                            >Aplicar</Button>
                        </Grid>

                        <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontWeight: 400}}>Subtotal:</Typography>
                        </Grid>

                        <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end', mt: 2}}>
                            <Typography>{datosPago ? formatoMoneda(obtenerValorTotal(datosPago.productos)) : formatoMoneda(obtenerValorTotal(productos))}</Typography>
                        </Grid>

                        {valorDescuento > 0 &&
                            <>
                                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: 0}}>
                                    <Typography sx={{fontWeight: 400}}>Descuentos:</Typography>
                                </Grid>

                                <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end', mt: 0}}>
                                    <Typography>{`- ${formatoMoneda(valorDescuento)}`}</Typography>
                                </Grid>
                            </>

                        }

                        <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontWeight: 400}}>Envio:</Typography>
                        </Grid>

                        {datosPago === null ?

                            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                                {cargandoCotizaciones ?
                                    <Skeleton variant={'rounded'} width={150}/>
                                    :
                                    <Typography>
                                        {valorEnvio >= 0 ? formatoMoneda(valorEnvio) : 'Sin datos de envio'}</Typography>
                                }


                            </Grid>


                            :

                            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end'}}>
                                <Typography>{formatoMoneda(datosPago.valorEnvio)}</Typography>
                            </Grid>


                        }


                        <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: 1}}>
                            <Typography sx={{fontWeight: 600, fontSize: 18}}>Total:</Typography>
                        </Grid>

                        {datosPago === null ?

                            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end', mt: 1}}>
                                <Typography sx={{fontWeight: 600}}>
                                    <span style={{fontSize: 14, fontWeight: 400, marginRight: 6}}>Cop</span>
                                    {valorEnvio >= 0 ? formatoMoneda(obtenerValorTotal(productos) + valorEnvio - valorDescuento) : 'Sin datos de envio'}
                                </Typography>
                            </Grid>

                            :

                            <Grid container size={{xs: 6, sm: 6, md: 6}} sx={{justifyContent: 'flex-end', mt: 1}}>
                                <Typography sx={{fontWeight: 600}}>
                                    <span style={{fontSize: 14, fontWeight: 400, marginRight: 6}}>Cop</span>
                                    {formatoMoneda(datosPago.valor)}
                                </Typography>
                            </Grid>


                        }


                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: 0}}>
                            <Typography sx={{fontWeight: 400, fontSize: 12, lineHeight: 1.4, color: '#00000080'}}>
                                <CheckCircle sx={{width: 14, height: 14, pr: 0.5, mt: 0.2, mb: -0.2}}/>
                                Pago seguro con <span style={{fontWeight: 700}}>Wompi,</span> Respaldado por <span
                                style={{fontWeight: 700}}>Bancolombia</span></Typography>
                        </Grid>


                        {datosPago &&

                            <>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Tarjeta_Estado_Pedido item={datosPago}/>
                                </Grid>


                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Tarjeta_Estado_Envio item={datosPago} click={consultarGuia}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Typography sx={{lineHeight: 1.2, fontSize: 14}}>
                                        <CheckCircle sx={{width: 14, height: 14, pr: 0.5, mt: 0.2, mb: -0.2}}/>
                                        Vuelve a este lugar si necesitas saber el estado de tu pedido</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 4}}>
                                    <Button
                                        startIcon={<ContentCopy/>}
                                        onClick={() => copiar()}
                                        variant={'outlined'} fullWidth>Copiar Link</Button>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Button
                                        startIcon={<ReplayOutlined/>}
                                        onClick={() => comprarNuevamente()}
                                        variant={'outlined'} fullWidth>Comprar Nuevamente</Button>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 2}}>
                                    <Button
                                        startIcon={<WhatsApp/>}
                                        onClick={() => iniciarChatWass({mensaje: 'Hola Amevi'})}
                                        variant={'outlined'} fullWidth>Comunicarme con atencion</Button>
                                </Grid>


                            </>

                        }


                    </Grid>

                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Checkout